export const normalizeFetchDisciplinesResponse = (response) => {
    return response.map(discipline => ({
        id: discipline.id,
        visualId: discipline.visual_id,
        name: discipline.name,
        description: discipline.description,
        conceptualLabels: discipline.conceptual_labels,
        isSystem: discipline.is_system
    })).sort((a, b) => a.visualId - b.visualId)
}